<template>
  <div class="result-facet" :class="{collapsed: isCollapsed}">
        <a class="result-facet-label" @click.prevent="toggleFacet" role="button" tabindex="0"><div><label>{{label}}</label><span class="result-toggle" role="img" :title="isCollapsed ? labels.showFacet:labels.hideFacet"></span></div></a>
        <ul>
            <slot>

            </slot>
        </ul>
      </div>
</template>

<script>
import { SessionState } from '../services/session-state.js'
import { Labels } from '../services/labels';

export default {
  name: 'Facet',
  props: [
    "facetId",
    "field",
    "label",
    "collapsed"
  ],
  components: {

  },
  created() {
    console.log(`Facet ${this.label} created.`);
  },
  beforeDestroy() {
    console.log(`Facet ${this.label} destroyed.`);
  },
  data() {
      return {
          isCollapsed: false,
          labels: Labels
      }
  },
  mounted() {
    this.isCollapsed = this.getCollapsedStatus();
  },
  methods: {
    toggleFacet() {
      console.log(`Facet ${this.label} toggled.`);
      this.isCollapsed = !this.isCollapsed;
      SessionState.set("facets", this.facetId, this.isCollapsed ? "1" : "0");
    },
    getCollapsedStatus() {
      //we see if this facet has been messed with in the current session. if not, we fall back to the default collapsed state
      var ret = false;
      var colStat = SessionState.get("facets", this.facetId);
      if (colStat) {
        ret = colStat === "1";
      } else {
        ret = this.collapsed || false;
      }
      return ret;
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.result-facet {
  margin-top: 15px;
  border-bottom: 1px solid #e4e4e4;
}

div.result-facet > .result-facet-label > div {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
}

div.result-facet > .result-facet-label > div > label {
    font-family: 'Gotham SSm A','Gotham SSm B',sans-serif;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    font-style: normal;
    text-transform: none;
    flex-grow:1;
    cursor: pointer;
    color: #323232;
}

div.result-facet > .result-facet-label > div > span {
  width: 16px;
  height: 16px;
  background-size: cover;
  background-repeat: none;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cpath fill='%232655FF' d='M 0,75 L 0,125 L 200,125 L 200,75 L 0,75 z'/%3E%3C/svg%3E");
  cursor: pointer;
}
div.result-facet.collapsed > .result-facet-label > div > span {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%232655FF' d='M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z'/%3E%3C/svg%3E");
}


div.result-facet > ul {
  margin-bottom:10px;
}

div.result-facet.collapsed > ul{
  display: none;
  
}

</style>